// ── App Preview (in-dashboard TV frame over /app/v1) ──
//
// D-2.6 transport: the preview fetches the PUBLIC /app/v1 contract directly
// from the platform content host, resolving tenancy with the same
// x-app-customer-domain header the Roku shell itself sends (SHApiBase +
// SHAppDomain). The content host serves /app/v1 with permissive CORS, so no
// dashboard-side proxy exists — keep it that way.

export const APP_PREVIEW_CONTENT_HOSTS = {
  streamhoster: 'https://c.streamhoster.com',
  whitelabel: 'https://c.themediacdn.com',
} as const;

export const APP_PREVIEW_TENANT_HEADER = 'x-app-customer-domain';

/**
 * Default platform param for preview fetches. Since 3.34.0 each TV tab passes
 * its own (`roku`, `firetv`): the home-screen layout the preview draws is the
 * shared one, but the cfg payload's platform block is the tab's.
 */
export const APP_PREVIEW_PLATFORM = 'roku';

export const APP_PREVIEW_QUERY_KEYS = {
  all: ['appPreview'] as const,
  cfg: (domain: string, platform: string) =>
    [...APP_PREVIEW_QUERY_KEYS.all, 'cfg', domain, platform] as const,
  browse: (domain: string, platform: string) =>
    [...APP_PREVIEW_QUERY_KEYS.all, 'browse', domain, platform] as const,
} as const;
